(function () {
  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function addItems(ids, button) {
    var list = (ids || [])
      .map(function (id) {
        return String(id || '').trim();
      })
      .filter(Boolean);
    if (!list.length) return Promise.resolve();
    if (!window.ScenarioCart || typeof window.ScenarioCart.addItems !== 'function') {
      return Promise.reject(new Error('cart unavailable'));
    }
    return window.ScenarioCart.addItems({
      items: list.map(function (id) {
        return { id: id, quantity: 1 };
      }),
      button: button,
      source: 'mic-creator'
    });
  }

  function relocateAnchorNav(root) {
    if (!root) return;
    var slot = root.querySelector('[data-om-anchor-slot]');
    var nav = document.querySelector('.event-anchor-nav');
    if (!slot || !nav) return;

    var wrap = nav.closest('[id^="shopify-section-"]');
    var omWrap = root.closest('[id^="shopify-section-"]');

    if (nav.parentNode !== slot) {
      slot.appendChild(nav);
    }
    nav.classList.add('is-placed');

    if (wrap && wrap !== omWrap) {
      wrap.setAttribute('hidden', '');
      wrap.style.display = 'none';
    }
  }

  function initRoot(root) {
    if (!root || root.dataset.omReady === 'true') return;
    root.dataset.omReady = 'true';

    relocateAnchorNav(root);
    initAddToCart(root);
    initCalendar(root);
    initEcosystem(root);
    initShopScene(root);
  }

  function initAddToCart(root) {
    root.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-om-bundle-add]');
      if (!btn || !root.contains(btn)) return;
      event.preventDefault();
      var ids = (btn.getAttribute('data-ids') || '').split(',');
      var ok = btn.parentElement && btn.parentElement.querySelector('[data-om-ok]');
      addItems(ids, btn)
        .then(function () {
          if (ok) ok.classList.add('is-on');
        })
        .catch(function () {});
    });
  }

  function initCalendar(root) {
    var cal = root.querySelector('[data-om-cal]');
    if (!cal) return;
    var grid = cal.querySelector('[data-om-cal-grid]');
    var label = cal.querySelector('[data-om-cal-label]');
    var prev = cal.querySelector('[data-om-cal-prev]');
    var next = cal.querySelector('[data-om-cal-next]');
    if (!grid || !label) return;

    var giftDays = [];
    var giftRanges = [];
    var jsonEl = cal.querySelector('[data-om-gifts]');
    if (jsonEl) {
      try {
        var parsed = JSON.parse(jsonEl.textContent || '{}');
        if (Array.isArray(parsed)) {
          parsed.forEach(function (g) {
            if (g && (g.start || g.end)) giftRanges.push(g);
            else giftDays.push(g);
          });
        } else {
          giftDays = parsed.days || [];
          giftRanges = parsed.ranges || [];
        }
      } catch (e) {
        giftDays = [];
        giftRanges = [];
      }
    }

    function pad(n) {
      return n < 10 ? '0' + n : String(n);
    }

    function parseYmd(raw) {
      var s = String(raw || '')
        .trim()
        .replace(/[./年]/g, '-')
        .replace(/日/g, '')
        .replace(/\s+/g, '-');
      s = s.replace(/-+/g, '-').replace(/^-|-$/g, '');
      var m = s.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);
      if (!m) return null;
      return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
    }

    function startOfDay(d) {
      return new Date(d.getFullYear(), d.getMonth(), d.getDate());
    }

    function weekStartOf(d) {
      return new Date(d.getFullYear(), d.getMonth(), d.getDate() - d.getDay());
    }

    function weekOverlapsRange(ws, rangeStart, rangeEnd) {
      if (!rangeStart || !rangeEnd) return true;
      var we = new Date(ws.getFullYear(), ws.getMonth(), ws.getDate() + 6);
      return ws.getTime() <= rangeEnd.getTime() && we.getTime() >= rangeStart.getTime();
    }

    function clampWeekStart(ws, rangeStart, rangeEnd) {
      if (!rangeStart || !rangeEnd) return ws;
      var minWs = weekStartOf(rangeStart);
      var maxWs = weekStartOf(rangeEnd);
      if (ws.getTime() < minWs.getTime()) return minWs;
      if (ws.getTime() > maxWs.getTime()) return maxWs;
      return ws;
    }

    var weekNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var today = startOfDay(new Date());
    var rangeStart = parseYmd(cal.getAttribute('data-cal-start'));
    var rangeEnd = parseYmd(cal.getAttribute('data-cal-end'));
    if (rangeStart && rangeEnd && rangeEnd.getTime() < rangeStart.getTime()) {
      var swap = rangeStart;
      rangeStart = rangeEnd;
      rangeEnd = swap;
    }
    var hasRange = Boolean(rangeStart && rangeEnd);

    var weekStart;
    if (hasRange) {
      if (today.getTime() < rangeStart.getTime()) weekStart = weekStartOf(rangeStart);
      else if (today.getTime() > rangeEnd.getTime()) weekStart = weekStartOf(rangeEnd);
      else weekStart = weekStartOf(today);
      weekStart = clampWeekStart(weekStart, rangeStart, rangeEnd);
    } else {
      weekStart = weekStartOf(today);
    }

    function inRange(date) {
      if (!hasRange) return true;
      var t = startOfDay(date).getTime();
      return t >= rangeStart.getTime() && t <= rangeEnd.getTime();
    }

    function giftLabel(date) {
      if (!inRange(date)) return '';
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      var d = date.getDate();
      var t = startOfDay(date).getTime();
      var exact = '';
      var ranged = '';

      giftRanges.forEach(function (g) {
        var text = (g && g.label) || '';
        if (!text) return;
        var gs = parseYmd(g.start);
        var ge = parseYmd(g.end);
        if (!gs || !ge) return;
        if (ge.getTime() < gs.getTime()) {
          var tmp = gs;
          gs = ge;
          ge = tmp;
        }
        if (t >= gs.getTime() && t <= ge.getTime()) ranged = text;
      });

      giftDays.forEach(function (g) {
        var raw = String((g && g.day) || '').trim();
        var text = (g && g.label) || '';
        if (!raw || !text) return;
        var giftDate = parseYmd(raw);
        if (giftDate) {
          if (
            giftDate.getFullYear() === y &&
            giftDate.getMonth() + 1 === m &&
            giftDate.getDate() === d
          ) {
            exact = text;
          }
        } else {
          var num = raw.match(/(\d{1,2})\s*$/);
          if (num && Number(num[1]) === d) exact = text;
        }
      });

      return exact || ranged;
    }

    function syncNav() {
      if (prev) {
        var prevWs = new Date(weekStart.getFullYear(), weekStart.getMonth(), weekStart.getDate() - 7);
        prev.disabled = hasRange && !weekOverlapsRange(prevWs, rangeStart, rangeEnd);
      }
      if (next) {
        var nextWs = new Date(weekStart.getFullYear(), weekStart.getMonth(), weekStart.getDate() + 7);
        next.disabled = hasRange && !weekOverlapsRange(nextWs, rangeStart, rangeEnd);
      }
    }

    function render() {
      var days = [];
      var i;
      for (i = 0; i < 7; i++) {
        days.push(new Date(weekStart.getFullYear(), weekStart.getMonth(), weekStart.getDate() + i));
      }
      var first = days[0];
      var last = days[6];
      if (first.getFullYear() !== last.getFullYear()) {
        label.textContent =
          months[first.getMonth()] +
          ' ' +
          first.getDate() +
          ', ' +
          first.getFullYear() +
          ' — ' +
          months[last.getMonth()] +
          ' ' +
          last.getDate() +
          ', ' +
          last.getFullYear();
      } else {
        label.textContent =
          months[first.getMonth()] +
          ' ' +
          first.getDate() +
          ' — ' +
          months[last.getMonth()] +
          ' ' +
          last.getDate() +
          ', ' +
          first.getFullYear();
      }

      grid.innerHTML = days
        .map(function (date) {
          var outside = !inRange(date);
          var gift = giftLabel(date);
          var cls = 'om-creator__cal-cell';
          if (outside) cls += ' is-out';
          if (gift) cls += ' is-gift';
          if (date.toDateString() === today.toDateString()) cls += ' is-today';
          return (
            '<div class="' +
            cls +
            '">' +
            '<span class="om-creator__cal-wday">' +
            weekNames[date.getDay()] +
            '</span>' +
            '<span class="om-creator__cal-num">' +
            date.getDate() +
            '</span>' +
            (gift ? '<span class="om-creator__cal-gift">' + gift.replace(/</g, '&lt;') + '</span>' : '') +
            '</div>'
          );
        })
        .join('');
      syncNav();
    }

    if (prev) {
      prev.addEventListener('click', function () {
        var nextWs = new Date(weekStart.getFullYear(), weekStart.getMonth(), weekStart.getDate() - 7);
        if (hasRange && !weekOverlapsRange(nextWs, rangeStart, rangeEnd)) return;
        weekStart = nextWs;
        render();
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        var nextWs = new Date(weekStart.getFullYear(), weekStart.getMonth(), weekStart.getDate() + 7);
        if (hasRange && !weekOverlapsRange(nextWs, rangeStart, rangeEnd)) return;
        weekStart = nextWs;
        render();
      });
    }
    render();
  }

  function initEcosystem(root) {
    var section = root.querySelector('[data-om-ecosystem]');
    if (!section) return;
    var preview = section.querySelector('[data-om-eco-preview]');
    var cells = section.querySelectorAll('td.yes');
    if (!preview || !cells.length) return;

    function show(cell) {
      var micImg = preview.querySelector('[data-bd-mic-img]');
      var camImg = preview.querySelector('[data-bd-cam-img]');
      var micName = preview.querySelector('[data-bd-mic-name]');
      var camName = preview.querySelector('[data-bd-cam-name]');
      var title = preview.querySelector('[data-bd-title]');
      var mic = cell.getAttribute('data-mic-name') || '';
      var cam = cell.getAttribute('data-cam-name') || '';
      var micSrc = cell.getAttribute('data-mic-img') || '';
      var camSrc = cell.getAttribute('data-cam-img') || '';
      var micId = (cell.getAttribute('data-mic-id') || '').trim();
      var camId = (cell.getAttribute('data-cam-id') || '').trim();
      var btn = preview.querySelector('[data-om-bundle-add]');
      var ok = preview.querySelector('[data-om-ok]');
      var ids = [micId, camId].filter(Boolean);
      if (micImg && micSrc) {
        micImg.src = micSrc;
        micImg.alt = mic;
      }
      if (camImg && camSrc) {
        camImg.src = camSrc;
        camImg.alt = cam;
      }
      if (micName) micName.textContent = mic;
      if (camName) camName.textContent = cam;
      if (title) title.textContent = mic + ' + ' + cam;
      if (btn) {
        btn.setAttribute('data-ids', ids.join(','));
        btn.disabled = ids.length < 2;
      }
      if (ok) ok.classList.remove('is-on');
      section.querySelectorAll('td.yes.is-active').forEach(function (el) {
        el.classList.remove('is-active');
      });
      cell.classList.add('is-active');
    }

    cells.forEach(function (cell) {
      cell.addEventListener('click', function () {
        show(cell);
      });
    });
    show(cells[0]);
  }

  function initShopScene(root) {
    var section = root.querySelector('[data-mic-shop-scene]');
    if (!section) return;
    var tabs = section.querySelectorAll('[data-mic-shop-tab]');
    var panels = section.querySelectorAll('[data-mic-shop-panel]');
    if (!tabs.length) return;

    var scroller = section.querySelector('[data-mic-shop-tabs]');
    var prev = section.querySelector('[data-mic-shop-prev]');
    var next = section.querySelector('[data-mic-shop-next]');

    function isMobileTabs() {
      return typeof window.matchMedia === 'function' && window.matchMedia('(max-width: 749px)').matches;
    }

    function tabsMaxScroll() {
      if (!scroller) return 0;
      return Math.max(0, scroller.scrollWidth - scroller.clientWidth);
    }

    function setArrowVisible(arrow, visible) {
      if (!arrow) return;
      arrow.classList.toggle('is-visible', !!visible);
      arrow.setAttribute('aria-hidden', visible ? 'false' : 'true');
    }

    function updateTabArrows() {
      if (!scroller || !prev || !next) return;
      if (!isMobileTabs()) {
        setArrowVisible(prev, false);
        setArrowVisible(next, false);
        return;
      }
      var maxScroll = tabsMaxScroll();
      if (maxScroll <= 2) {
        setArrowVisible(prev, false);
        setArrowVisible(next, false);
        return;
      }
      var sl = scroller.scrollLeft;
      setArrowVisible(prev, sl > 4);
      setArrowVisible(next, sl < maxScroll - 4);
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var key = tab.getAttribute('data-mic-shop-tab');
        tabs.forEach(function (t) {
          t.classList.toggle('is-active', t === tab);
        });
        panels.forEach(function (panel) {
          panel.hidden = panel.getAttribute('data-mic-shop-panel') !== key;
        });
        if (scroller && isMobileTabs() && typeof tab.scrollIntoView === 'function') {
          tab.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
        }
        updateTabArrows();
      });
    });

    if (scroller && prev && next) {
      scroller.addEventListener('scroll', updateTabArrows, { passive: true });
      prev.addEventListener('click', function () {
        scroller.scrollTo({ left: 0, behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        scroller.scrollTo({ left: tabsMaxScroll(), behavior: 'smooth' });
      });
      window.addEventListener('resize', updateTabArrows);
      updateTabArrows();
    }
  }

  ready(function () {
    document.querySelectorAll('[data-om-creator]').forEach(initRoot);
  });

  document.addEventListener('shopify:section:load', function (event) {
    var root = document.querySelector('[data-om-creator]');
    if (!root) return;
    relocateAnchorNav(root);
    var loaded = event.target && event.target.querySelector('[data-om-creator]');
    if (loaded) {
      delete loaded.dataset.omReady;
      initRoot(loaded);
    }
  });
})();
